// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a7073c7c]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.save-btn[data-v-a7073c7c]{background:#3d46f5;border-radius:120px;color:#fff;font-size:16px;height:32px;line-height:32px;text-align:center;width:96px}.save-btn[data-v-a7073c7c]:hover{color:hsla(0,0%,100%,.6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
